// extracted by mini-css-extract-plugin
module.exports = {"headerTitle":"ReportingDashboard_headerTitle__2_OVw","filter":"ReportingDashboard_filter__h5PQx"};